var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.frontpage = {
	init: function() {
		if (!$('body').hasClass('frontpage')) return false;

	}
};

// Run all the inits \o/
$(function() {
	site.frontpage.init();

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Touch login
	$('.login').dblclick(function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);

	$('#store #productForm').submit(function(e) {
		$('#store .priceWrap').find('input.num').each(function() {
			if (this.value == '')
				this.value = '0';
		});
	});
	$("#store .categories li.product, #store .categoryProducts li.product").each(function() {
		var $this = $(this);
		$this.click(function() {
			location.href = $("h3 a",this).attr("href");
		});
	});

	$('#mainmenu .level1:not(.selectedLevel1) .mmLevel2').addClass('hide');

	$('#mainmenu li.level1.children > a').click(function(e) {
		$mm2 = $(this).next();
		if ($mm.hasClass('mmLevel2') && !$mm2.is(':visible')) {
			e.preventDefault();
			$mm2.show();
		}
	});

	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	/* SEARCH */
	$("#searchToggle").click(function() {
		if (!$("#searchBox").hasClass("open")) {
			$("#searchBox").addClass("open");
		}
		else {
			$("#searchBox").addClass("closing");
		}
		$("#searchBox .boxText").slideToggle(400, function() {
			if ($("#searchBox").hasClass("closing")) {
				$("#searchBox").removeClass("open").removeClass("closing");

			}
		});
	});

	$("#singlePromo").each(function () {
		var $this = $(this);
		var $nextSibling = $this.closest('.box').next();
		console.log($nextSibling);
		$this.append('<a class="mini-nav effect" href="#' + $nextSibling.attr('id') + '"></a>');
	})

});

/* Mobile menu and searchbar */
$(function(){
	var scrollPosition;
	$('#mainmenuToggle').click(function(e) {
		var menuOpen = $('body').hasClass('open-menu');
		if (!menuOpen) {
			scrollPosition = $(window).scrollTop();
		}
		menuToggle(e);
		if (!menuOpen) {
			$(window).scrollTop(0);
		}
		else {
			$(window).scrollTop(scrollPosition);
		}
	});

	$('#mMenu .level1').prepend('<a class="expand" href="#" title=""><span>+</span></a>');
	$('#mMenu ul.mmLevel1 > li').not(':has(ul)').removeClass('children')
	$('#mMenu .expand').click(function(e) {
		e.preventDefault();
		$('> ul',this.parentNode).toggle();
		$('> ul',this.parentNode).toggleClass('hide');
		$('> a',this.parentNode).toggleClass('down');
	});
});

function menuToggle(e) {
	e.preventDefault();
	$('body').toggleClass('open-menu');
	$(this).toggleClass('open');
	return false;
}

$(function() {
	$(".entry img").addClass(function(){
		var floated = $(this).css("float");
		return (floated != "none") ? "f" + floated : "";
	});
	$("#mMenu .selectedLevel1 .expand").addClass("down");

	$('#footerContent .contact').each(function () {
		var bc = $(this);
		bc.html(bc.html().replace(/\|/g,'<span class="slash divider">/</span>'));
		bc.html(bc.html().replace(/\\/g,'<span class="slash">/</span>'));
	});

	if ($('body').hasClass('about') || $('body').hasClass('gluten')) {
		var goto = ($('body').hasClass('about')) ? 'about' : 'box_pagecontent_12';
		$(window).load(function () {
			$("#promo").append('<a class="mini-nav effect" href="#'+goto+'"></a>');
		});
	}
	$(window).load(function () {
		$('a[href*=#]:not([href=#])').click(function() {
			var $body = $('body');
			if ($body.hasClass('admin')) return false;

			if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
				var headerHeight = $('#header').height(),
					offset = headerHeight;

				if ($('body').width()+15 < 992) {
					offset = 52;
				}

				if ($body.hasClass('loggedIn')) {
					offset+=31;
				}
				if (target.length) {
					$('html,body').animate({
						scrollTop: target.offset().top-offset
					}, 1000);
					return false;
				}
			}
		});
	});
	//Fixed menu
	if(document.addEventListener) {
		document.addEventListener("touchmove", ScrollStart, false);
		document.addEventListener("scroll", ScrollStart, false);
		var minScroll = 10;
		var fClass = 'sticky';
	}

	function ScrollStart() {
		var scrollTop = $(window).scrollTop();
		if (scrollTop > minScroll){
			$('#header').addClass(fClass);
		}else{
			$('#header').removeClass(fClass);
		}
	}

});
